import React from 'react';
import './_house-model.scss';
export type HouseModelProps = {
    imgSrc: string;
    name: string;
}

export default function HouseModel({imgSrc, name}: HouseModelProps) {
    return (<div className="house-model">
        <img src={imgSrc} alt="House Model"/>
        <span>{name}</span>
    </div>);
}
